export default __webpack_public_path__ + "static/media/GOOGLE-1.bd55cb08.png";